import { render, staticRenderFns } from "./VQTable.vue?vue&type=template&id=c0b728fa"
import script from "./VQTable.vue?vue&type=script&lang=js"
export * from "./VQTable.vue?vue&type=script&lang=js"
import style0 from "./VQTable.vue?vue&type=style&index=0&id=c0b728fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports